<div class="login--banner">
  Welcome! We are Aiwyn, the new payments processor for {{company}}. If this is your first time here, please <span style="font-weight: bold">create an account</span> using your associated {{company}} email to access your invoicing details.
</div>
